import type { SourceTokenRow } from '../../openpencil-figma/openpencil-source-library-model'
import { adviseAxes } from './advise'
import type { DesignAxesCopy } from './axes-copy'
import { deriveAxes } from './derive-axes'
import type { SourceDerivedDesignSystem } from './types'

export interface SourceTokenSnapshot {
  kind: 'figma' | 'document'
  label: string
  tokens: SourceTokenRow[]
}

export interface DeriveFromSourceInput {
  projectId: string
  /** 소스를 읽는 책임은 호출자에게 있다 — 이 함수는 순수 조립만 한다. */
  loadTokens: () => Promise<SourceTokenSnapshot>
  /**
   * 축 설명 문구 로케일 (axes-copy.ts). React 표면은 활성 로케일 사전을
   * 넘기고, 기계 채널(WebMCP 등)은 생략해 KO 기본값을 유지한다.
   */
  copy?: DesignAxesCopy
}

export const DERIVE_FROM_SOURCE_CAPABILITY = 'cogo.studio.designSystem.deriveFromSource'

/**
 * 소스를 읽지 못하면 던진다. 조용히 프리셋으로 대체하지 않는다 — 그렇게 하면
 * 사용자는 자기 소스가 무시된 것을 모른 채 앱을 받게 된다.
 */
export async function deriveFromSource(
  input: DeriveFromSourceInput,
): Promise<SourceDerivedDesignSystem> {
  const snapshot = await input.loadTokens()
  const axes = adviseAxes(deriveAxes(snapshot.tokens, input.copy), input.copy)
  return {
    projectId: input.projectId,
    source: {
      kind: snapshot.kind,
      label: snapshot.label,
      variableCount: snapshot.tokens.length,
    },
    axes,
    derivedAt: new Date().toISOString(),
  }
}
